var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-loader",
    class: {
      inactive: _vm.inactive
    }
  }, [_c('div', {
    staticClass: "progress-loader-overlay"
  }), _c('div', {
    staticClass: "progress-loader-bar",
    style: {
      width: _vm.calcWidth
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }